import React from 'react';
import ClientDirectory from '../ClientDirectory';
import '../../pages/Client.css';
import '../../pages/ClientDetail.css';

/** The Client page's directory, rendered as a Service and Support tab. */
const ServiceClientsTab: React.FC = () => <ClientDirectory />;

export default ServiceClientsTab;
